import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { IBenchConsultant } from "../../models/BenchConsultant";
import { Fetch } from "../../shared/Fetch";
import { IBenchSubmission, Submission } from "./Submission";
import { History } from "./History";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";


interface Iprops {
    singleData: IBenchConsultant,
    open: boolean,
    hideDialog: () => void,
    toast: any,
}

export const BenchSubmissionList = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBenchSubmission>, loading: boolean });

    useEffect(() => {
        if (props.singleData.consultant_ID) loadTableData();
    }, [props.singleData.consultant_ID]);

    const [submissionForm, setSubmissionForm] = useState({ singleData: {}, open: false } as { singleData: IBenchSubmission, open: boolean });
    const hideSubmissionFormDialog = () => { setSubmissionForm({ singleData: {}, open: false }) };
    const [history, setHistory] = useState({ submission_ID: 0, consultant_Name: '', open: false } as { submission_ID: number, consultant_Name: string | undefined, open: boolean });
    const hideHistory = () => {
        setHistory({ submission_ID: 0, consultant_Name: '', open: false });
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Consultant_Bench/submissionList", "GET", null, `consultant_ID=${props.singleData.consultant_ID}`, props.toast);
        if (response) {
            const data: Array<IBenchSubmission> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const submittedDate = (rowData: IBenchSubmission) => {
        let date;
        if (rowData.submittedDate) date = format(new Date(rowData.submittedDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const submissionStatus = (rowData: IBenchSubmission) => {
        return (
            <span onClick={() => setSubmissionForm({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.submissionStatus}
            </span>
        );
    };
    const bLifeCycle = (rowData: IBenchSubmission) => {
        return (
            <Button onClick={() => { if (rowData.submission_ID) setHistory({ submission_ID: rowData.submission_ID, consultant_Name: rowData.consultant_Name, open: true }) }} icon="pi pi-history" className="p-button-rounded p-button-secondary p-button-text" aria-label="History" />
        );
    };
    const onHide = () => {
        props.hideDialog();
        setTableData({ tableData: [], loading: false });
    }


    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Bench Submission List" modal className="p-fluid" onHide={onHide}>
            <DataTable className="field col-12 md:col-12" style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" value={tableData.tableData} loading={tableData.loading} showGridlines
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                {/* <Column field="submittedDate" header="Submitted Date" body={submittedDate} /> */}
                <Column field="submittedDate" header="Submitted Date" body={(rowData : any) => safeFormatDate(rowData.submittedDate, 'dd/MM/yyyy' ,DateFormat)} />
                <Column field="sales_Manager" header="Sales Manager" />
                <Column field="consultant_Name" header="Consultant" />
                <Column field="client" header="Prime Vendor" />
                <Column field="endClient" header="Client" />
                <Column field="location" header="Location" />
                <Column field="rate" header="Rate" />
                <Column field="interviewMode" header="MOI" />
                <Column field="submissionStatus" header="Submission Status" body={submissionStatus} />
                <Column field="lifeCycle" header="LifeCycle" body={bLifeCycle} />
            </DataTable>
            <Submission onHide={onHide} singleData={submissionForm.singleData} open={submissionForm.open} hideDialog={hideSubmissionFormDialog} toast={props.toast} />
            <History open={history.open} submission_ID={history.submission_ID} consultant_Name={history.consultant_Name} toast={props.toast} hideDialog={hideHistory} />
        </Dialog>
    );
}
